import h from 'react-hyperscript';
import { getIconByNpoType } from '../../enums/npoTypes';

const NpoIcon = ({ type, ...rest }) => h('img.npo-type', { src: getIconByNpoType(type), ...rest });

export default NpoIcon;



// WEBPACK FOOTER //
// ./src/components/Npos/NpoIcon.js